/**
 * Deduplica peticiones concurrentes: mientras un GET a un endpoint está en vuelo,
 * cualquier llamada nueva a esa misma ruta se engancha a la promesa existente en
 * vez de disparar un segundo request. No cachea: cuando la promesa se resuelve la
 * entrada se borra y la siguiente llamada vuelve a pedir al servidor.
 */
class ServiceSync {
  static readonly instance = new ServiceSync();
  private constructor() {}

  private readonly _running = new Map<string, Promise<void>>();

  run(key: string, fn: () => Promise<void>): Promise<void> {
    const running = this._running.get(key);
    if (running) return running;
    const task = fn().finally(() => { this._running.delete(key); });
    this._running.set(key, task);
    return task;
  }
}

export const serviceSync = ServiceSync.instance;
